import Vue from "vue";
import VueRouter from "vue-router";
import home from "@/pages/home/home";
import appLayout from "@/pages/app/layout";
import appLayoutInvite from "@/pages/app/layoutInvite";
import agentHome from "@/pages/app/agent/home/home";
import appSite from "@/pages/home/site";
import appReferral from "@/pages/home/referral";

import userLayout from "@/pages/app/agent/user/layout";
import myDeals from "@/pages/app/agent/user/mydeal/mydeal";

import applicationLayout from "@/pages/app/agent/user/app/layout"
import applicationStart from "@/pages/app/agent/user/app/start/start"

import applicantLayout from "@/pages/app/agent/user/app/applicant/layout"

import contactme from '@/pages/app/agent/user/contactme'
import resetpassword from '@/pages/app/agent/forgotpassword/forgotpassword'

import applicationAddCoApplicant from '@/pages/app/agent/user/app/applicant/addCoApplicant'

import coApplicant from '@/pages/app/agent/user/app/applicant/coApplicant'
import coApplicantInvite from '@/pages/app/agent/user/app/applicant/coApplicantInvite'
import applicationIdentification from "@/pages/app/agent/user/app/applicant/identification";
import applicationAddress from "@/pages/app/agent/user/app/applicant/address";
import applicantIncome from '@/pages/app/agent/user/app/applicant/income'
import applicantProperty from '@/pages/app/agent/user/app/applicant/property'
import applicantAsset from '@/pages/app/agent/user/app/applicant/asset'
import applicantLiability from '@/pages/app/agent/user/app/applicant/liability'

import applicationInviteCoApplicant from '@/pages/app/agent/user/app/applicant/InviteCoApplicant/addCoApplicant'
import applicationInviteCoApplicantV2 from '@/pages/app/agent/user/app/applicant/InviteCoApplicant/addCoApplicantV2'
import applicationIdentificationInvite from "@/pages/app/agent/user/app/applicant/InviteCoApplicant/identification";
import applicationAddressInvite from "@/pages/app/agent/user/app/applicant/InviteCoApplicant/address";
import applicantIncomeInvite from '@/pages/app/agent/user/app/applicant/InviteCoApplicant/income'
import applicantPropertyInvite from '@/pages/app/agent/user/app/applicant/InviteCoApplicant/property'
import applicantAssetInvite from '@/pages/app/agent/user/app/applicant/InviteCoApplicant/asset'
import applicantLiabilityInvite from '@/pages/app/agent/user/app/applicant/InviteCoApplicant/liability'

import mortgageRequestInvite from '@/pages/app/agent/user/app/mortgage/mortgageInvite'
import mortgageRequest from '@/pages/app/agent/user/app/mortgage/mortgage'
import requestDocument from '@/pages/app/agent/user/app/requestDocument/requestDocument'
import bankStatement from '@/pages/app/agent/user/app/requestDocument/bankStatement'
import mortgageSummary from '@/pages/app/agent/user/app/summary/summary'
import mortgageSummaryInvite from '@/pages/app/agent/user/app/summary/summaryInvite'
import mortgageSuccess from '@/pages/app/agent/user/app/success/success'
import mortgageSuccessInvite from '@/pages/app/agent/user/app/success/successInvite'

import privacyPage from '@/pages/home/privacy'
import termsPage from '@/pages/home/terms'
import disclosurePage from '@/pages/home/disclosure'
import loginas from '@/pages/app/agent/loginas/loginas'

import docLayout from '@/pages/doc/layout'
import ReqLayout from "@/pages/app/layoutReqDoc"
import docStart from '@/pages/doc/start'
import docUpload from '@/pages/doc/upload/upload_v2' 
import docContact from '@/pages/doc/contact/contact'
 
import cliLayout from '@/pages/app/cli/layout'
import security from '@/pages/app/cli/security'
import applicationForm from '@/pages/app/cli/applicationform'
import esign from '@/pages/app/cli/esign'
import cal from '@/pages/C21/cal'

import embeddedForms from "@/pages/app/embedded-forms/index";

const offline =()=>import('@/pages/home/offline');

Vue.use(VueRouter);
const routes = [  
  // {
  //   path: '/:catchAll(.*)',
  //   component: offline
  // },   
  {
    path: "/cooperators",
    component: ()=>import('@/pages/cumis/layout'),
    children:[
      { path: "application/:id" , component:()=>import('@/pages/cumis/application') },
      { path: "thankyou/:id", component: ()=>import('@/pages/cumis/applicationThankYou') },
      { path: "quote/:id", component: ()=>import('@/pages/cumis/quote')}
    ]
  },
  {
    path: "/c21/cal",
    component: cal
  },
  {
    path: "/",
    component: home
  },

  {
    path: "/embedded-forms/:token",
    component: embeddedForms
  },
  
  {
    path:"/privacy",
    component: privacyPage
  },
  {
    path:"/terms",
    component: termsPage
  },
  {
    path:"/disclosure",
    component: disclosurePage
  },
  {
    path:'/:siteid/reqdoc/upload/:requestdocid',
    component: docStart
  },
  {
    path:"/:siteid/doc/:requestdocid",
    component: ReqLayout,
    children:[
      {
        path: 'upload',
        component: docUpload
      },
      {
        path: 'contact',
        component: docContact
      }
    ]
  },
  {
    path: "/:siteid",
    component: appSite
  },
  {
    path: "/:siteid/referral",
    component: appReferral
  },
  {
    path: "/:siteid",
    component: appLayout,   
    children: [             
      {
        path: 'loginas/:uid',
        component: loginas
      },
      {
        path: 'resetpassword/:cachekey',
        component: resetpassword
      },
      {
        name: "agentHome",
        path: "home", 
        component: agentHome
      },
      {
        path: "user",
        component: userLayout,
        children: [          
          {
            path: 'contactme',
            component: contactme
          },
          {
            path: "mydeals",
            component: myDeals
          },
          {
            path: ":appid",
            component: applicationLayout,
            children: [
              {
                name: "appStart",
                path: "start",
                component: applicationStart
              },
              {
                path: 'addCoApplicant',
                component: applicationAddCoApplicant
              },
              {
                path: "applicant",
                component: applicantLayout,
                children:[                
                  {
                    path:':applicantid/identification',
                    component:applicationIdentification       
                  },
                  {
                    path:':applicantid/address',
                    component:applicationAddress
                  },
                  {
                    path:':applicantid/income',
                    component:applicantIncome
                  },
                  {
                    path:':applicantid/property',
                    component: applicantProperty
                  } ,
                  {
                    path:':applicantid/asset',
                    component: applicantAsset
                  },
                  {
                    path:':applicantid/liability',
                    component: applicantLiability
                  }
                ]
              },
              {
                path: 'mortgage',
                component: mortgageRequest
              },
              {
                path: 'request',
                component: requestDocument
              },
              {
                path: 'bankStatement',
                component: bankStatement
              },
              {
                path: 'summary',
                component: mortgageSummary
              },{
                path: 'success',
                component: mortgageSuccess
              },{
                path: 'coApplicant',
                component: coApplicant
              },
              {
                path: 'coApplicantInvite',
                component: coApplicantInvite
              }             
             
            ]
          }
        ]
      }
    ]
  },
  {
    path: "/:siteid",
    component: appLayoutInvite,   
    children: [                   
      {
        path: "InviteCoApplicant",
        component: userLayout,
        children: [                   
          {
            path: ":appid/:guid",
            component: applicationLayout,
            children: [             
              {
                path: 'addCoApplicant',
                component: applicationInviteCoApplicant
              },                                          
              {
                path: 'success',
                component: mortgageSuccessInvite
              },
              {
                path: 'coApplicant',
                component: coApplicant
              },  
              {
              path: "applicant",
              component: applicantLayout,
              children:[                
                {
                  path:':applicantid/identification',
                  component:applicationIdentificationInvite       
                },
                {
                  path:':applicantid/address',
                  component:applicationAddressInvite
                },
                {
                  path:':applicantid/income',
                  component:applicantIncomeInvite
                },
                {
                  path:':applicantid/property',
                  component: applicantPropertyInvite
                } ,
                {
                  path:':applicantid/asset',
                  component: applicantAssetInvite
                },
                {
                  path:':applicantid/liability',
                  component: applicantLiabilityInvite
                },   
                {
                  path: 'addCoApplicantV2',
                  component: applicationInviteCoApplicantV2
                },  
                {
                  path: 'mortgage',
                  component: mortgageRequestInvite
                },                
                {
                  path:'summary',
                  component: mortgageSummaryInvite
                },
                {
                  path: 'success',
                  component: mortgageSuccessInvite
                },
              ]
            },                                           
            {
              path: 'coApplicant',
              component: coApplicant
            },          
             
            ]
          },
         
        
        ]
      }
    ]
  },
  {
    path: "/:siteid/cli",
    component: cliLayout,
    children:[
        {
          path:"application/:token",
          component:security
        },
        {
          path:"application/:token/form",
          component:applicationForm
        },
        {
          path:"application/:token/esign",
          component:esign
        }
    ]
  }
 
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
